import { ActionableNotification } from '@carbon/react';
import { useAtom, useSetAtom } from 'jotai';

import { openReconcileModalAtom, promotionPendingAtom } from './atoms';

/**
 * Non-intrusive banner shown when another workspace for this entity was
 * promoted (INS-9740). Offers a "Review changes" action that opens the reconcile
 * (pull-in) modal; dismissing clears the pending flag. Never refetches on its
 * own and never closes an open confirm panel — the user opts in on their own
 * schedule.
 *
 * @return {JSX.Element | null} The banner, or null when no promotion is pending.
 */
export const PromotionPendingBanner = (): JSX.Element | null => {
  const [pending, setPending] = useAtom(promotionPendingAtom);
  const openReconcileModal = useSetAtom(openReconcileModalAtom);

  if (!pending) return null;

  const promoter = pending.promotedByName
    ? ` by ${pending.promotedByName}`
    : '';

  return (
    <ActionableNotification
      kind="info"
      lowContrast
      inline
      title="Certified interests updated"
      subtitle={`Another workspace for this entity was promoted${promoter}. Review and pull in the changes when you're ready.`}
      actionButtonLabel="Review changes"
      onActionButtonClick={() => openReconcileModal()}
      onClose={() => {
        setPending(null);
        return true;
      }}
    />
  );
};
